import React, { useState } from "react";
import {Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Button, useDisclosure, Spinner} from "@nextui-org/react";
import axios from "axios";
import { baseUrlLink, order_uri, orders_uri, product_uri } from "../../../../utils/url";
import { toast } from "react-toastify";
import { PRODUCT_TYPES } from "../../../../utils/types";

export default function OrderDetailModal({data,id, callback}) {
  const {isOpen, onOpen, onOpenChange} = useDisclosure();
  const [pay, setPay] = useState();
  const [load, setLoad] = useState(false);

  const call = () =>{
    callback();
  }

  const Sub = async()=>{
    setLoad(true);
    try{
        const res = await axios.post(product_uri+'/payed', {id: id});
        if(res.status === 200){
            toast.success("Амжилттай");
            setPay('');
            call();
            onOpenChange(false)
            setLoad(false)
        }
    }catch(err){
        console.log(err);
        setLoad(false);
    }
  }

  return (
    <>
      <Button size='sm' onClick={onOpen} className="ml-2">Захиалгын дэлгэрэнгүй</Button>
      <Modal size="3xl" isOpen={isOpen} onOpenChange={onOpenChange}>
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader className="flex flex-col gap-1">Захиалгын дэлгэрэнгүй</ModalHeader>
              <ModalBody>
                <table className="min-w-full divide-y divide-gray-200 table-fixed dark:divide-gray-700">
                  <thead className="bg-gray-50 dark:bg-gray-700">
                    <tr>
                      <th scope="col" className="p-4 text-sm font-normal">
                        No
                      </th>
                      <th scope="col" className="py-2 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                        Бараа
                      </th>
                      <th scope="col" className="py-2 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                        Өнгө
                      </th>
                      <th scope="col" className="py-2 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                        Хэмжээ
                      </th>
                      <th scope="col" className="py-2 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                       Тоо
                      </th>
                    </tr>
                  </thead>
                  {
                    load?
                    <div className='flex items-center justify-center  p-4'>
                      <Spinner/>
                      <h1 className=''>Уншиж байна ...</h1>
                    </div>
                    :
                    <tbody className="bg-white divide-y divide-gray-200 dark:bg-gray-800 dark:divide-gray-700">
                      {
                        data.map((item, index) => {
                          return(
                            <tr className="hover:bg-gray-100 dark:hover:bg-gray-700" key={index}>
                              <td className="p-2 w-4 text-center">
                                <img className="" src={baseUrlLink+item.product.images[0].url}/>
                              </td>
                              <td className="py-2 px-6 text-sm font-bold text-gray-900 whitespace-nowrap dark:text-white flex flex-col">
                                {item.product.name}
                              </td>
                              <td className="py-2 px-6 text-sm font-bold text-gray-500  dark:text-white text-overflow">
                                {item.color?.name}
                              </td>
                              <td className="py-2 px-6 text-sm font-medium text-gray-500  dark:text-white text-overflow">
                              {item.size?.value}
                              </td>
                              <td className="py-2 flex items-center gap-2 px-6 text-sm font-medium text-gray-500  dark:text-white text-overflow">
                                {item.quantity}
                                {
                                  item.product.product_type == PRODUCT_TYPES.BELEN ?
                                  <div className="bg-green-600 p-1 text-xs text-white rounded-md">Бэлэн</div>
                                  :
                                  <div className="bg-orange-600 p-1 text-xs text-white rounded-md">Захиалгын</div>
                                }
                              </td>
                            </tr>
                          )
                        })
                      }
                    </tbody>
                  }
                </table>
              </ModalBody>
              <ModalFooter>
                <Button color="danger" variant="light" onClick={onClose}>
                  Close
                </Button>
                {
                    load?
                    <Button className="bg-blue-300">
                        Баталгаажуулж байна ...
                    </Button>
                    :
                    <Button color="primary" onClick={Sub}>
                        Төлбөр төлсөн
                    </Button>
                }
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  );
}
